import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import { initLenis, destroyLenis, scrollTop } from "@/lib/scroll";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => scrollTop(), [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="App bg-[#F7F5F0] text-[#1A1918]">
        <div className="grain-overlay" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <FloatingContact />
      </div>
    </BrowserRouter>
  );
}

export default App;
